// mantine
import { Title } from '@mantine/core';
// components
import type { TSessionByLeads } from '@newo/api/gateway';
import StatItem from '@/pages/Report/components/StatItem';
import TotalSessionsAreaChart from '@/pages/Report/components/TotalSessions/components/TotalSessionsAreaChart';
import { getSessionsPageLinks } from '@/pages/Report/Report.utils';
import EmptyView from '@/pages/Report/components/EmptyView';
// utils
import { hints } from '@/pages/Report/Report.data';

interface TotalSessionsProps {
    data: TSessionByLeads;
    deals: number;
}

const TotalSessions = ({ data, deals }: TotalSessionsProps) => {
    const sessionsPageLinks = getSessionsPageLinks();
    return (
        <div className="space-y-4">
            <Title order={3} size="h3">
                Total Sessions Count Handled:
            </Title>
            <div className="flex flex-col md:flex-row md:justify-between gap-5 pb-2">
                <div className="text-xs text-gray-6 leading-relaxed max-w-lg mr-auto">
                    The number of communication sessions including voice calls,
                    SMS sessions and live chat sessions handled by your Newo AI
                    Employee including both leads and non-leads except the test
                    sessions.
                </div>
                <StatItem
                    hint={hints.totalSessions}
                    title="Total Sessions Count"
                    to={sessionsPageLinks.totalSessionsCountLink}
                    value={data.total_sessions}
                />
                <StatItem
                    hint={hints.totalLeadCount}
                    title="Total Lead Count"
                    to={sessionsPageLinks.totalLeadCountLink}
                    value={data.total_sessions_leads}
                />
                <StatItem
                    hint={hints.totalAdditionalDealCount}
                    title="Total Additional Deal Count"
                    value={deals}
                    valueClassName="text-cyan-5 border-cyan-5"
                />
            </div>

            {data.items.length === 0 ? <EmptyView /> : undefined}
            {data.items.length > 0 ? (
                <TotalSessionsAreaChart data={data} />
            ) : undefined}
        </div>
    );
};

export default TotalSessions;
